import "./App.css";
import Header from "./components/Header";
import Login from "./components/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Panel from "./components/Panel";
import Home from "./components/Home";
import Getotp from "./components/Getotp";
import Recharge from "./components/Reacharge";
import Transactions from "./components/Transactions";
import Support from "./components/Support";

import {auth} from './firebase.js';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/panel" element={<Panel />}></Route>
          <Route path="/recharge" element={<Recharge />}></Route>
          <Route path="/getotp" element={<Getotp />}></Route>
          <Route path="/transactions" element={<Transactions />}></Route>
          <Route path="/support" element={<Support />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
